const containerStack = {
  padding: { xs: '2.5rem 2rem 4rem 2rem', ipad: '2.5rem 6rem 4rem 6rem' },
  borderRadius: '0 0 2rem 2rem',
  background: 'linear-gradient(180deg, #000 0%, #1A284C 100%)',
};

const photoContainer = {
  width: '100%',
  height: '100%',
  marginTop: '2rem',
  marginBottom: '-2rem',
  marginInline: 'auto',
};

const photoStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '2rem',
};

const secretPhotoContainer = {
  width: '100%',
  height: '100%',
};

const flippyStyles = {
  backgroundColor: 'transparent',
  width: '100%',
  marginTop: '3rem',
};

const flippySideStyles = {
  borderRadius: 18,
  padding: 0,
  boxShadow: 'none',
};

const buttonTypography = {
  color: 'white',
  fontWeight: 600,
};

export {
  containerStack,
  photoContainer,
  photoStyles,
  secretPhotoContainer,
  flippyStyles,
  flippySideStyles,
  buttonTypography,
};
